import { useEffect, useRef } from "react";
import { Pagination as ZhPagination, type PaginationProps } from "zhihao-ui-react";

/** 统一恢复旧 Vue ProTable 的分页布局，并保留调用方显式关闭或覆盖各项配置的能力。 */
export function AdminPagination({
    current = 1,
    pageSizeOptions = [10, 20, 30, 40, 50, 100],
    showQuickJumper = true,
    showSizeChanger = true,
    showLessItems = false,
    showTotal = total => `共${total}条数据`,
    ...props
}: PaginationProps) {
    const paginationHostRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!showQuickJumper) {
            return;
        }

        // Ant 分页快速跳转输入框默认为空，Vue 旧版会展示当前页（初始为 1）。
        // 在公共适配层补齐默认值，避免每个列表页重复处理且不干扰用户正在输入的内容。
        // zhihao Pagination 会在自身副作用中刷新快速跳转节点，放到当前渲染任务之后可确保
        // 默认值写入发生在该刷新之后，同时不干扰用户正在输入的内容。
        const timer = window.setTimeout(() => {
            const input = paginationHostRef.current?.querySelector<HTMLInputElement>(
                ".ant-pagination-options-quick-jumper input"
            );
            if (input && (!input.value || document.activeElement !== input)) {
                input.value = String(current);
            }
        }, 0);
        return () => window.clearTimeout(timer);
    }, [current, showQuickJumper]);

    return (
        <div ref={paginationHostRef} className="admin-pagination-host">
            <ZhPagination
                {...props}
                current={current}
                pageSizeOptions={pageSizeOptions}
                showLessItems={showLessItems}
                showQuickJumper={showQuickJumper}
                showSizeChanger={showSizeChanger}
                showTotal={showTotal}
            />
        </div>
    );
}

export default AdminPagination;
